import { Descriptions, DescriptionsProps } from 'antd'

import { useStyles } from './styles'

type Props = React.PropsWithChildren<DescriptionsProps>

export const DetailsWrapper = ({ children, ...props }: Props) => {
  const { styles } = useStyles()

  return (
    <>
      {children}

      <Descriptions
        column={1}
        classNames={{ content: styles.detailContent, root: styles.detailRoot }}
        {...props}
      />
    </>
  )
}
